/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MeterReadingType = {
    NotSpecified: 'NotSpecified',
    Accumulated: 'Accumulated',
    Balanced: 'Balanced',
    None: 'None',
} as const;
export type MeterReadingType = typeof MeterReadingType[keyof typeof MeterReadingType];

